import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Passenger } from 'src/app/core/models/itinerary.model';
import {
  CabinRowSeat,
  ReservationSeat,
  ReserveSeatConfirmation,
  SeatAvailableStatus,
  SeatSelected,
  SeatSelectedByPassenger,
  SeatSelectedEnum,
  SeatSelectedOption
} from 'src/app/core/models/seat.model';

@Component({
  selector: 'app-seat',
  templateUrl: './seat.component.html',
  styleUrls: ['./seat.component.scss']
})
export class SeatComponent implements OnInit {
  @Input() seatInfo: CabinRowSeat;
  @Input() flightNumber: number;
  @Input() seatNumber: string;
  @Input() preReserveSeat: string;
  @Input() rowNumber: string;
  @Input() passengers: Passenger[];
  @Input() seatListsReserved: ReservationSeat[];
  @Input() selectedSeats: SeatSelectedOption[];
  @Input() reserveSeatResult: ReserveSeatConfirmation;

  @Output() selectedSeat = new EventEmitter<SeatSelectedByPassenger>();
  @Output() removeSelectedSeat = new EventEmitter<string>();
  @Output() resetSelectedSeat = new EventEmitter<string>();

  actionForm: FormGroup;
  actionType = '';
  passengersAvailable = [];
  isDisabledSeat = false;
  showAction = false;
  loadingSelection = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.passengersAvailable = this.passengers.map((p: Passenger) => ({
      code: p.id,
      name: `${p.firstName} ${p.lastName}`
    }));
    if (
      !(
        this.seatInfo.occupation === SeatAvailableStatus.SEATISFREE ||
        this.seatInfo.occupation === SeatAvailableStatus.ADVANCEDSEATSELECTIONSEAT ||
        this.seatInfo.occupation === SeatAvailableStatus.OTHER
      )
    ) {
      this.isDisabledSeat = this.isReserveSeatResult() ? false : true;
    }
    this.buildForm();
  }

  validSeatReserved() {
    return this.seatListsReserved.find(
      (option) =>
        option.seatSelect.number === `${this.rowNumber}${this.seatNumber}` &&
        Number(option.segmentSelect.number) === this.flightNumber
    );
  }

  validSeatIsSelected() {
    return this.selectedSeats.find((seat) => seat.seat === `${this.rowNumber}${this.seatNumber}`);
  }

  buildForm() {
    this.actionForm = this.fb.group({
      actionType: ['', Validators.required]
    });
  }

  changeAction() {
    this.actionType = this.actionForm.controls.actionType.value;
  }

  selectSeatByPassenger() {
    const seatSelected: SeatSelected = {
      seat: `${this.rowNumber}${this.seatNumber}`,
      action: !this.validSeatIsSelected()
        ? SeatSelectedEnum.add
        : this.validSeatIsSelected()?.passengerId === this.actionType
        ? SeatSelectedEnum.remove
        : SeatSelectedEnum.add,

      cancelation: this.isDisabledSeat
    };
    this.selectedSeat.emit({ seatSelected, passengerId: this.actionType });
    this.hideAction();
  }

  removeOrResetSelection(isReset: boolean) {
    isReset
      ? this.resetSelectedSeat.emit(this.actionType)
      : this.removeSelectedSeat.emit(this.preReserveSeat);
    this.actionForm.reset();
    this.hideAction();
  }

  selectSeatAction() {
    this.showAction = true;
  }

  isValidSelection() {
    return this.actionType === '';
  }

  hideAction() {
    this.showAction = false;
  }

  allowCancel() {
    return this.seatListsReserved.find(
      (option) =>
        option.nameSelect.nameNumber === this.actionType &&
        option.seatSelect.number === `${this.rowNumber}${this.seatNumber}` &&
        Number(option.segmentSelect.number) === this.flightNumber
    );
  }

  isCancelation(): boolean {
    if (this.reserveSeatResult?.lSeats[0]?.number) {
      return this.reserveSeatResult?.lSeats[0]?.number === this.rowNumber + this.seatNumber;
    } else {
      return this.preReserveSeat === this.rowNumber + this.seatNumber;
    }
  }

  isReserveSeatResult(): boolean {
    if (this.reserveSeatResult?.lSeats[0]?.number) {
      return this.reserveSeatResult?.lSeats[0]?.number === this.rowNumber + this.seatNumber;
    } else {
      return this.preReserveSeat === this.rowNumber + this.seatNumber;
    }
  }
}
